import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { AccordionSummary } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import StatusChip from 'components/StatusChip';
import { StyledCaption, StyledShortBody } from 'components/Requests/styles';
import { StyledAccordionDetails } from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/MyRequests/styles';
import messages from 'components/Requests/messages';
import { translate } from 'helpers/intl';
import { REQUESTS_STATUSES } from 'constants/amcStatuses';
import { ShortBody } from 'components/Typography';

interface RequestDetailsType {
  intl: IntlShape;
  request: {
    NUM_DECLMARATION: string;
    NOM_PRENOM_ASSURE: string;
    SORT: string;
    MONTANT_REGLE: number;
    DATE_SURVENANCE: string;
    DATE_REGLEMENT: string;
    RIB: string;
    MODE_REGLEMENT: string;
    NUM_SINISTRE: string;
    FRAIS_ENGAGE: number;
  };
  isLoading: boolean;
  expanded: boolean | String;
  index: string;
}

const RequestDetails = ({
  request,
  expanded,
  index,
  isLoading,
  ...props
}: RequestDetailsType) => {
  const renderDetails = (item: any) => {
    switch (item.SORT) {
      case REQUESTS_STATUSES.CREATED:
        return (
          <StatusChip
            status={'warning'}
            label={translate(get(messages, 'statusCreated'), props)}
          />
        );
      case REQUESTS_STATUSES.VALIDATED:
        return (
          <StatusChip
            status={'success'}
            label={translate(get(messages, 'statusValidated'), props)}
          />
        );
      case REQUESTS_STATUSES.REJECTED:
        return (
          <StatusChip
            status={'error'}
            label={translate(get(messages, 'statusRejected'), props)}
          />
        );
    }
  };
  return (
    <>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Box width="100%">
          <Grid container justify="space-between">
            <Grid item xs={12} sm={3}>
              <Grid item>
                <StyledCaption>
                  {translate(get(messages, 'requestDate'), props)}
                </StyledCaption>
              </Grid>
              <Grid item>
                <Box marginBottom={0}>
                  <StyledShortBody>{request.DATE_REGLEMENT}</StyledShortBody>
                </Box>
              </Grid>
            </Grid>
            <Grid item xs={6} sm>
              <Grid container direction="column">
                <Grid item>
                  <StyledCaption>
                    {translate(get(messages, 'folderNature'), props)}
                  </StyledCaption>
                </Grid>
                <Grid item>
                  <ShortBody>{request.NOM_PRENOM_ASSURE}</ShortBody>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} sm>
              <Grid container direction="column">
                <Grid item>
                  <StyledCaption>
                    {translate(get(messages, 'expensesIncurred'), props)}
                  </StyledCaption>
                </Grid>
                <Grid item>
                  <ShortBody>{request.FRAIS_ENGAGE}</ShortBody>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} sm>
              <Grid container direction="column">
                <Grid item>
                  <StyledCaption>
                    {translate(get(messages, 'status'), props)}
                  </StyledCaption>
                </Grid>
                <Grid item>
                  <Box marginBottom={0}>{renderDetails(request)}</Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} sm>
              <Grid container direction="column">
                <Grid item>
                  <StyledCaption>
                    {translate(get(messages, 'folderReference'), props)}
                  </StyledCaption>
                </Grid>
                <Grid item>
                  <ShortBody>{request.NUM_DECLMARATION}</ShortBody>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </AccordionSummary>
      {expanded && index === expanded && (
        <StyledAccordionDetails>
          <Box width="100%">
            <Grid container justify="space-between">
              {/* <Grid item xs={6} sm>
                <Grid container direction="column">
                  <Grid item>
                    <StyledCaption>
                      {translate(get(messages, 'lossDate'), props)}
                    </StyledCaption>
                  </Grid>
                  <Grid item>
                    <ShortBody>{refund.DATE_SURVENANCE}</ShortBody>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sm>
                <Grid container direction="column">
                  <Grid item>
                    <StyledCaption>
                      {translate(get(messages, 'claimNumber'), props)}
                    </StyledCaption>
                  </Grid>
                  <Grid item>
                    <Grid item>
                      <ShortBody>{refund.NUM_SINISTRE}</ShortBody>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid> */}
              <Grid item xs={6} sm></Grid>
              <Grid item xs={6} sm></Grid>
            </Grid>
          </Box>
        </StyledAccordionDetails>
      )}
    </>
  );
};

export default injectIntl(RequestDetails);
